export default __webpack_public_path__ + "static/media/jobSideMarker.dae4e28b.svg";